"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGE_STABLECOINS_UNAVAILABLE_COUNTRIES = exports.BRIDGE_UNAVAILABLE_STATES = exports.BRIDGE_UNAVAILABLE_COUNTRIES = void 0;
exports.BRIDGE_UNAVAILABLE_COUNTRIES = {
    AFG: 'Afghanistan',
    ALB: 'Albania',
    BDI: 'Burundi',
    BFA: 'Burkina Faso',
    BGD: 'Bangladesh',
    BIH: 'Bosnia and Herzegovina',
    BLR: 'Belarus',
    BRB: 'Barbados',
    BTN: 'Bhutan',
    BWA: 'Botswana',
    CAF: 'Central African Republic',
    CHN: 'China',
    CMR: 'Cameroon',
    COD: 'Democratic Republic of the Congo',
    CUB: 'Cuba',
    DZA: 'Algeria',
    ECU: 'Ecuador',
    ERI: 'Eritrea',
    ESH: 'Western Sahara',
    ETH: 'Ethiopia',
    GIN: 'Guinea',
    GMB: 'Gambia',
    GNB: 'Guinea-Bissau',
    GRD: 'Grenada',
    HTI: 'Haiti',
    IRN: 'Iran',
    IRQ: 'Iraq',
    JAM: 'Jamaica',
    JOR: 'Jordan',
    KEN: 'Kenya',
    KHM: 'Cambodia',
    LBN: 'Lebanon',
    LBR: 'Liberia',
    LBY: 'Libya',
    MAR: 'Morocco',
    MDG: 'Madagascar',
    MKD: 'Macedonia',
    MLI: 'Mali',
    MMR: 'Myanmar',
    MOZ: 'Mozambique',
    NER: 'Niger',
    NGA: 'Nigeria',
    NIC: 'Nicaragua',
    NPL: 'Nepal',
    PAK: 'Pakistan',
    PRK: 'North Korea',
    PSE: 'Palestine',
    QAT: 'Qatar',
    RUS: 'Russia',
    SDN: 'Sudan',
    SEN: 'Senegal',
    SLB: 'Solomon Islands',
    SOM: 'Somalia',
    SSD: 'South Sudan',
    SUR: 'Suriname',
    SVN: 'Slovenia',
    SYC: 'Seychelles',
    SYR: 'Syria',
    TCA: 'Turks and Caicos Islands',
    TGO: 'Togo',
    TON: 'Tonga',
    TTO: 'Trinidad and Tobago',
    TUR: 'Turkey',
    TZA: 'Tanzania',
    UGA: 'Uganda',
    UKR: 'Ukraine',
    VEN: 'Venezuela',
    VNM: 'Vietnam',
    VUT: 'Vanuatu',
    XKX: 'Kosovo',
    YEM: 'Yemen',
    ZAF: 'South Africa',
    ZWE: 'Zimbabwe',
};
exports.BRIDGE_UNAVAILABLE_STATES = {
    FL: 'Florida',
    AK: 'Alaska',
    LA: 'Louisiana',
};
exports.BRIDGE_STABLECOINS_UNAVAILABLE_COUNTRIES = {
    MMR: 'Myanmar',
};
